/* eslint-disable new-cap */
import { createContext, useReducer } from 'react';
import Immutable from 'seamless-immutable';

const notificationsReducer = (state, action) => {
  switch (action.type) {
    case 'add':
      return state.setIn(action.data.created, action.data);
    case 'remove':
      return state.without(action.id);
    default:
      return state;
  }
};

export const useNotificationsStore = () => {
  const [ notificationsObject, dispatch ] = useReducer(notificationsReducer, Immutable({}));
  return [ Object.values(notificationsObject), dispatch ];
};

export default createContext(() => Immutable({}));
